module.exports = __webpack_public_path__ + "static/tjykdxzyy-0e2bc6b10df62278631ea6c31cc0ed23.jpg";